export enum FileType {
  measurement = 'measurement_report',
  summary = 'report',
  prescription = 'prescription',
  billingReport = 'billing_report',
}

export const generateFilename = (id: string, type: FileType) => `Fib_${type}_${id}`;

export function downloadFile(fileUrl: string, id: string, type: FileType) {
  // Download file my forcing a press on new anchor element
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = generateFilename(id, type);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
